module.exports = __webpack_public_path__ + "static/media/microplating-low-profile.1bddfdc5.png";